// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 895) return "895/895.836adb7ef37d0fbe628f.min.css";
	if (chunkId === 268) return "events/events.b1752772c67d65b424ea.min.css";
	// return url for filenames based on template
	return undefined;
};